import { createSelector, createSlice } from '@reduxjs/toolkit';
import { executeCallbackFunction } from '../../../helpers/callback.js';
import { redirect } from '../../../helpers/url/url.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { saveCandidateJustLoggedInCookie } from '../../../helpers/storage/cookies.js';
import { setActiveView, WRAPPER_TYPES, } from '../wrapperContext/wrapperContextSlice.js';
import { dispatchLoginSuccessEvent } from '../../../helpers/dispatchLoginSuccessEvent.js';
import { getLastLoginMethod, saveLastLoginMethod, } from '../../../helpers/storage/storage.js';
import { shouldSkipRedirect } from './helper/index.js';
export const AUTH_SOURCES = {
    apple: 'apple',
    facebook: 'facebook',
    email: 'email',
    linkedin: 'linkedIn',
    google: 'google',
};
export const initialAuthSuccessState = {
    source: null,
    code: null,
    lastLoginMethod: getLastLoginMethod(),
};
export const authSuccessSlice = createSlice({
    name: 'authSuccess',
    initialState: initialAuthSuccessState,
    reducers: {
        setAuthSuccess: (state, action) => {
            state.source = action.payload.source;
            state.code = action.payload.code;
        },
        setLastLoginMethod: (state, action) => {
            state.lastLoginMethod = action.payload;
        },
    },
});
const authSuccessState = (state) => state.core.authSuccess;
export const authSuccessSelector = createSelector(authSuccessState, ({ source, code }) => {
    return {
        ...(source && { source }),
        ...(code && { code }),
    };
});
export const { setAuthSuccess, setLastLoginMethod } = authSuccessSlice.actions;
export const authSuccessThunk = (source, codeOrNull, additionalAuthData) => async (dispatch, getState) => {
    const state = getState();
    /* update status code only if it's passed in the thunk */
    const code = codeOrNull ?? state.core.authSuccess.code;
    dispatch(setAuthSuccess({ source, code }));
    if (source) {
        dispatch(setLastLoginMethod(source));
        saveLastLoginMethod(source);
    }
    const { redirectionUrl, callbackFunction } = state.core.sourceData;
    const { activeWrapper, activeView } = state.core.wrapperContext;
    const { showRegistrationSuccessfulModal } = state.forms.registration;
    // comment out this code to disable the interstitial view for Apple login
    if (source === 'apple') {
        const { emailUpdateRequired, skipEmailUpdate } = additionalAuthData?.apple || {};
        if (emailUpdateRequired && !skipEmailUpdate) {
            const { activeWrapper } = state.core.wrapperContext;
            // Check if in two-step wrapper flow
            if (activeWrapper === WRAPPER_TYPES.STEP_MODAL) {
                // TODO: replace that with navigateTo
                dispatch(setActiveView(FORM_TYPES.TWO_STEP_APPLE_UPDATE_EMAIL));
                return;
            }
        }
    }
    dispatchLoginSuccessEvent();
    await executeCallbackFunction(callbackFunction);
    saveCandidateJustLoggedInCookie();
    const skipRedirect = shouldSkipRedirect({
        activeWrapper,
        activeView,
        showRegistrationSuccessfulModal,
    });
    if (!skipRedirect) {
        redirect(redirectionUrl);
    }
};
export const lastLoginMethodSelector = createSelector(authSuccessState, ({ lastLoginMethod }) => lastLoginMethod);
export default authSuccessSlice.reducer;
//# sourceMappingURL=authSuccessSlice.js.map